import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import dayjs from "dayjs";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
// both below component are added ---->
import ConnectedCallTable from "./CallingRequiredComponent/ConnectedCallTable";
import MissedCallAgentTable from "./CallingRequiredComponent/MissedCallAgentTable";
import FilterComponent from "./FilterCompoenent";
import FilterListIcon from "@mui/icons-material/FilterList";
import Loader from "../reusable Component/Loader";
import {
  AGENT_INCOMMING_CALL_COUNTS,
  AGENT_INCOMMING_CONNECTED_CALL,
  AGENT_INCOMMING_MISSED_CALL,
} from "../../constants";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

function IncomingCallAgent() {
  const [loading, setLoading] = useState(false);

  // for api calling---->
  const [incoming, setIncoming] = useState(null);
  const [incomingConnected, setIncomingConnected] = useState(null);
  const [incomingMissed, setIncomingMissed] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");

  // this is for top filter button and component ---->

  const Local_EmployeePhone = JSON.parse(
    localStorage.getItem("userData")
  ).EmployeePhone;

  const [filters, setFilters] = useState({
    startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"), // 7 days ago
    endDate: dayjs().format("YYYY-MM-DD"),
    page: 1,
    pageSize: 10,
  });
  const [missedFilters, setMissedFilters] = useState({
    page: 1,
    pageSize: 10,
  });
  const [connectedFilters, setConnectedFilters] = useState({
    page: 1,
    pageSize: 10,
  });

  const [filterShow, setFilterShow] = useState(false);

  // clears the filter when you refresh

  // FETCH DATA FROM API FOR INCOMING CALL COUNTS----------------------->

  const agent = JSON.parse(localStorage.getItem("userData"));
  const agentNumber = agent?.EmployeePhone;

  // 1️⃣ Fetch incoming counts (independent of pagination)
  useEffect(() => {
    const fetchIncomingCounts = async () => {
      try {
        if (!filters.startDate || !filters.endDate) return;

        const query = new URLSearchParams({
          startDate: filters.startDate,
          endDate: filters.endDate,
          agentNumber, // use agentNumber explicitly for counts
        }).toString();

        const res = await axios.get(`${AGENT_INCOMMING_CALL_COUNTS}?${query}`);
        setIncoming(res.data);
      } catch (error) {
        console.error("Error fetching incoming counts", error);
        setMessage("Error loading incoming counts");
        setSeverity("error");
        setOpenSnackbar(true);
      }
    };

    fetchIncomingCounts();
  }, [filters, agentNumber]);

  // 2️⃣ Fetch incoming connected + missed (with pagination)
  useEffect(() => {
    const fetchIncomingCalls = async () => {
      try {
        if (!filters.startDate || !filters.endDate) return;
        setLoading(true);

        const buildQueryforMissed = (extraParams = {}) => {
          const query = new URLSearchParams({
            startDate: filters.startDate,
            endDate: filters.endDate,
            aPartyNo: agentNumber,
            ...(missedFilters.page ? { page: missedFilters.page } : {}),
            ...(missedFilters.pageSize
              ? { pageSize: missedFilters.pageSize }
              : {}),
            ...extraParams,
          });
          return query.toString();
        };

        console.log("filters before buildQuery:", filters);
        const buildQuery = (extraParams = {}) => {
          const query = new URLSearchParams({
            startDate: filters.startDate,
            endDate: filters.endDate,
            aPartyNo: agentNumber, // default for call details
            ...(connectedFilters.page ? { page: connectedFilters.page } : {}),
            ...(connectedFilters.pageSize
              ? { pageSize: connectedFilters.pageSize }
              : {}),
            ...extraParams,
          });
          return query.toString();
        };

        const [connectedRes, missedRes] = await Promise.all([
          axios.get(`${AGENT_INCOMMING_CONNECTED_CALL}?${buildQuery()}`),
          axios.get(`${AGENT_INCOMMING_MISSED_CALL}?${buildQueryforMissed()}`),
        ]);

        setIncomingConnected(connectedRes.data);
        setIncomingMissed(missedRes.data);
      } catch (error) {
        console.error("Error fetching incoming calls", error);
        setMessage("Error loading incoming calls");
        setSeverity("error");
        setOpenSnackbar(true);
      } finally {
        setLoading(false);
      }
    };

    fetchIncomingCalls();
  }, [filters, agentNumber, missedFilters, connectedFilters]); // includes pagination inside filters

  console.log("incoming", incoming);
  console.log("connected", incomingConnected);
  console.log("missed", incomingMissed);

  const [metricData, setMetricData] = useState([]);
  const [tabValues, setTabValues] = useState(0); // Default to the first tab

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValues(newValue);
    //   const getfilterData = localStorage.getItem("agentFilters");
    // if (getfilterData) {
    //   setFilters(JSON.parse(getfilterData));
    // }
  };
  return (
    <>
      {loading && <Loader open={loading} />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
        >
          Incoming Call Report
        </Typography>

        {/* IconButton aligned to the right */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Box>
      {filterShow && (
        <FilterComponent
          filters={filters}
          setFilters={setFilters}
          setFilterShow={setFilterShow}
        ></FilterComponent>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        gap="16px"
        sx={{
          padding: "16px",
          backgroundColor: "#EEF0F4",
          borderRadius: "8px",
          marginTop: "10px",
          marginBottom: "16px",
        }}
      >
        {/* Total Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {incoming?.summary?.totalCalls || 0}
          </Typography>
        </Box>

        {/* Connected Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Connected Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {incoming?.summary?.connectedCalls || 0}
          </Typography>
        </Box>

        {/* Missed Calls */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Missed Calls
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {incoming?.summary?.missedCalls || 0}
          </Typography>
        </Box>

        {/* Total Talk time */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
            boxShadow: 2,
            width: "30%",
          }}
        >
          <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
            Total Connected Time
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#333333" }}
          >
            {incoming?.summary?.totalDuration || 0}
          </Typography>
        </Box>
      </Box>
      <></>
      <Tabs
        value={tabValues} // Current selected tab
        onChange={handleTabChange} // Handle tab change
        aria-label="Call Statistics Tabs"
      >
        <Tab
          // label={`Connected (${incomingConnected?.connectedCallCount || 0})`}
          label={`Connected (${incomingConnected?.connectedCallCount || 0})`}
          id="tab-0"
          aria-controls="tabpanel-0"
        />
        <Tab
          // label={`Missed (${incomingMissed?.missedCallCount || 0})`}
          label={`Missed (${incomingMissed?.missedCallCount || 0})`}
          id="tab-1"
          aria-controls="tabpanel-1"
        />
      </Tabs>
      {/* Tab Panels */}
      <TabPanel value={tabValues} index={0}>
        <ConnectedCallTable
          filters={filters}
          connectedFilters={connectedFilters}
          setConnectedFilters={setConnectedFilters}
          setFilters={setFilters}
          setLoading={setLoading}
          incomingConnected={incomingConnected}
        />
      </TabPanel>

      <TabPanel value={tabValues} index={1}>
        <MissedCallAgentTable
          filters={filters}
          missedFilters={missedFilters}
          setMissedFilters={setMissedFilters}
          setFilters={setFilters}
          setLoading={setLoading}
          incomingMissed={incomingMissed}
        />
      </TabPanel>
    </>
  );
}

export default IncomingCallAgent;
